import { zeroAddress } from 'viem'

/**
 * imTokenWeb Paymaster 支持的 ERC20 代币地址（按网络分类）
 *
 * @see home-of-token-web/src/lib/wallet/config.ts networkConfigs.paymasterModes
 */
export const IMTOKEN_WEB_PAYMASTER_TOKENS_BY_CHAIN: Record<number, string[]> = {
  // Sepolia (testnet)
  11155111: [
    zeroAddress, // ETH
    '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238', // USDC
    '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14', // WETH
    '0xC8c4EFA54D6774F55DD09134a901865ff286321e', // DAI
    '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984', // UNI
    '0x6C1851b852F05bdc7c0BE1A088532E4999fD94Fa', // LON
    '0x7fA5E99D78FB17379C467B3dC5D0F63AcED6a80D', // WBTC
    '0x63b26b83c6f38433B2b6a7214fC2c569a4F4069A', // USDT
    '0x779877A7B0D9E8603169DdbD7836e478b4624789', // LINK
  ],
  // Arbitrum One (mainnet)
  42161: [
    zeroAddress, // ETH
    '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', // USDT
    '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', // DAI
    '0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0', // UNI
    '0x55678cd083fcDC2947a0Df635c93C838C89454A3', // LON
    '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f', // WBTC
    '0xaf88d065e77c8cC2239327C5EDb3A432268e5831', // USDC
    '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', // WETH
  ],
  // Optimism Mainnet
  10: [
    zeroAddress, // ETH
    '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58', // USDT
    '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', // DAI
    '0x6fd9d7AD17242c41f7131d257212c54A0e816691', // UNI
    '0x68f180fcCe6836688e9084f035309E29Bf0A2095', // WBTC
    '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85', // USDC
    '0x4200000000000000000000000000000000000006', // WETH
  ],
}

